import { forwardRef } from 'react';
import type { ButtonHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

export interface BulkToolbarButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** `danger` renders the design's light-coral destructive label (#FFC9B5). */
  readonly tone?: 'default' | 'danger';
}

/** Text button on the navy toolbar: 30px, 0 10px, radius 8, 13px/500, paper-12% hover. */
export const BulkToolbarButton = forwardRef<HTMLButtonElement, BulkToolbarButtonProps>(
  function BulkToolbarButton({ tone = 'default', className, type = 'button', ...rest }, ref) {
    return (
      <button
        ref={ref}
        type={type}
        className={cn(
          'h-[30px] whitespace-nowrap rounded-lg border-0 bg-transparent px-2.5 text-[13px] font-medium hover:bg-on-navy-hover',
          'disabled:cursor-not-allowed disabled:opacity-40',
          tone === 'danger' ? 'text-on-navy-danger' : 'text-pi-paper',
          className,
        )}
        {...rest}
      />
    );
  },
);
